import { z } from "zod/v4";

import { ShopifyProductStatusList } from "../../../schemas/shopify";

export const SetDuplicateProductsRequestBodySchema = z.object({
  experienceId: z.uuid(),
  status: z.enum(ShopifyProductStatusList),
  delayHours: z.number().optional(),
});

export type SetDuplicateProductsRequestBodyType = z.infer<
  typeof SetDuplicateProductsRequestBodySchema
>;

export const SetDuplicateProductsResponseBodySchema = z.string();

export type SetDuplicateProductsResponseBodyType = z.infer<
  typeof SetDuplicateProductsResponseBodySchema
>;
